<template>
  <div id="app">
    <router-view :type="feedType" />
  </div>
</template>

<script>
import './mock'

export default {
  name: 'App',
  computed: {
    feedType() {
      return this.$route.query.type || 'images'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5f5;
}

#app {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
}
</style> 